
namespace TabAurous.ProductDevelopment {
    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class PDInterfaceDialog extends _Ext.DialogBase<PDInterfaceRow,any> {
        protected getFormKey() { return 'ProductDevelopment.PDInterface' }
        protected getLocalTextPrefix() { return PDInterfaceRow.localTextPrefix; }
        protected getDeletePermission() { return PDInterfaceRow.deletePermission; }
        protected getInsertPermission() { return PDInterfaceRow.insertPermission; }
        protected getUpdatePermission() { return PDInterfaceRow.updatePermission; }
        public form = new  PDInterfaceForm(this.idPrefix);
        protected get_ExtDialogOptions() {
            let opt = super.get_ExtDialogOptions();
            opt.AutoFitContentArea = false;
            return opt;
        }

        constructor() {
            super(); 
            var Config = Q.deepClone(q.DefualtEditorOptions);
            Config.height = 700;
            q.initDetailEditor(this, this.form.CustomerRequirements, Config);
            q.initDetailEditor(this, this.form.Designing, Config);
            q.initDetailEditor(this, this.form.SpecSheets, Config);
            q.initDetailEditor(this, this.form.Quotations, Config);
            q.hideEditorLabel(this.form.CustomerRequirements); 


            q.initDetailEditor(this, this.form.Designing, Config);
            q.hideEditorLabel(this.form.Designing);

            q.initDetailEditor(this, this.form.SpecSheets, Config);
            q.hideEditorLabel(this.form.SpecSheets); 


            q.initDetailEditor(this, this.form.Quotations, Config);
            q.hideEditorLabel(this.form.Quotations);
        }
        protected onDialogOpen() {
            super.onDialogOpen();
            this.set_dialogTitle("Product Dashboard");
            this.setGridData();
        }
        protected getToolbarButtons() {
            let self = this;
            let buttons = super.getToolbarButtons();
            buttons = buttons.filter(x => x.cssClass == "");
            buttons.push({
                title: "",
                cssClass: "btn-refresh",
                icon: "fa-refresh",
                onClick: () => {
                    self.setGridData();
                }
            });

            return buttons;
        }
        public setGridData() {
            CustomerRequirementItemsService.PDInterfaceList({ Take: 0, StatusId: 23}, response => {
                if (response.Entities != null && response.Entities.length > 0)
                    this.form.CustomerRequirements.setData(response.Entities);
            }, { async: false });
            CustomerRequirementItemsService.PDInterfaceList({ Take: 0,StatusId:24 }, response => {
                if (response.Entities != null && response.Entities.length > 0)
                    this.form.Designing.setData(response.Entities);
            }, { async: false });
            SpecSheetItemsService.List({ Take: 0 }, response => {
                if (response.Entities != null && response.Entities.length > 0)
                    this.form.SpecSheets.setData(response.Entities);
            }, { async: false });
            PDQuotationItemsService.QuotationCreatedBySpecSheet({ Take: 0 }, response => {
                if (response.Entities != null && response.Entities.length > 0)
                    this.form.Quotations.setData(response.Entities);
            }, { async: false });
        }
    }
   
}